import { render, staticRenderFns } from "./CandidateSelect.vue?vue&type=template&id=54444c7a&"
import script from "./CandidateSelect.vue?vue&type=script&lang=js&"
export * from "./CandidateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports